import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Anchor from 'common-ui-components/dist/components/Atoms/Anchor';
import Button from 'common-ui-components/dist/components/Atoms/Button';
import EmptyContainer from 'common-ui-components/dist/components/Atoms/EmptyContainer';
import { ReactSVG } from 'react-svg';
import LinkAndLabel from '../ShoppingCart/LinkAndLabel';
import './ShoppingCartEmpty.scss';
import { USER_STATE_LOGGED_IN, SET_SIGN_IN_REDIRECT_KEY } from '../../../global/constants';
import { isQuoteFeatureEnabled } from '../../../utils/utils';

const ShoppingCartEmpty = props => {
  const {
    userState,
    labels,
    signInUrl,
    continueShoppingUrl,
    userIcon,
    removeAllItemsIconUrl,
    alreadyHaveAQuote,
    isAccountBlocked,
    openBlockedAccountModal,
    isQuoteToOrderDisabled,
    checkoutButtonDisabled,
    openEndSessionModal,
  } = props;

  const [quoteIsDisabled, setQuoteIsDisabled] = useState(false);
  const isQuoteEnabled = isQuoteFeatureEnabled();

  const checkAccountBlocked = (e, callback) => {
    if (isAccountBlocked) {
      openBlockedAccountModal(e);
      setQuoteIsDisabled(true);
    } else {
      callback(true);
    }
  };

  return (
    <EmptyContainer className="container center-xs shoppingCartEmpty">
      <div className="emptyContainer-message" data-locator="empty-cart-message">
        {labels.emptyCartMessage}
      </div>
      <Anchor to={continueShoppingUrl} elementLocator="link-shopping-cart-empty-continue-shopping">
        <Button className="primary" elementLocator="button-shopping-cart-empty-continue-shopping">
          {labels.buttonContinueShopping}
        </Button>
      </Anchor>
      {userState !== USER_STATE_LOGGED_IN ? (
        <div className="center-xs row container" data-locator="empty-cart-item-went">
          {labels.itemsWent}
          <Anchor
            className="row"
            elementLocator="link-shopping-cart-empty-sign-in"
            to={signInUrl}
            {...{
              onClick: () => {
                window.sessionStorage.setItem(SET_SIGN_IN_REDIRECT_KEY, window.location.href);
              },
            }}
          >
            <ReactSVG src={userIcon} />
            {labels.signIn}
          </Anchor>
        </div>
      ) : (
        labels.eProc === 'true' && (
          <div
            className="center-xs row container empty-cart-link-and-label"
            data-locator="empty-cart-link-and-label"
          >
            <LinkAndLabel
              onClick={openEndSessionModal}
              labelLink={labels.endSession}
              labelMessage={labels.eprocEmptyCart}
              iconUrl={removeAllItemsIconUrl}
            />
          </div>
        )
      )}
      {isQuoteEnabled && !checkoutButtonDisabled && !isQuoteToOrderDisabled && (
        <>
          <div className="center-xs row already-have-a-quote container">
            {userState !== USER_STATE_LOGGED_IN ? (
              <Anchor
                className="row"
                elementLocator="link-shopping-cart-already-have-a-quote-sign-in"
                to={signInUrl}
                {...{
                  onClick: () => {
                    window.sessionStorage.setItem(SET_SIGN_IN_REDIRECT_KEY, window.location.href);
                  },
                }}
              >
                {labels.alreadyHaveAQuote}
              </Anchor>
            ) : (
              !quoteIsDisabled && (
                <Anchor
                  className="row"
                  elementLocator="link-shopping-cart-already-have-a-quote"
                  to="#"
                  {...{ onClick: e => checkAccountBlocked(e, alreadyHaveAQuote) }}
                >
                  {labels.alreadyHaveAQuote}
                </Anchor>
              )
            )}
          </div>
        </>
      )}
    </EmptyContainer>
  );
};

ShoppingCartEmpty.propTypes = {
  userState: PropTypes.oneOf(['LOGGED_IN', 'ANONYMOUS']),
  labels: PropTypes.shape({
    emptyCartMessage: PropTypes.string,
    buttonContinueShopping: PropTypes.string,
    itemsWent: PropTypes.string,
    signIn: PropTypes.string,
    eprocEmptyCart: PropTypes.string,
    endSession: PropTypes.string,
    eProc: PropTypes.string,
    alreadyHaveAQuote: PropTypes.string,
  }),
  signInUrl: PropTypes.string,
  continueShoppingUrl: PropTypes.string,
  userIcon: PropTypes.string,
  removeAllItemsIconUrl: PropTypes.string,
  alreadyHaveAQuote: PropTypes.func,
  isAccountBlocked: PropTypes.bool,
  openBlockedAccountModal: PropTypes.func,
  isQuoteToOrderDisabled: PropTypes.bool,
  checkoutButtonDisabled: PropTypes.bool,
  openEndSessionModal: PropTypes.func,
};

ShoppingCartEmpty.defaultProps = {
  userState: {},
  labels: {},
  signInUrl: '',
  continueShoppingUrl: '',
  userIcon: '/static/images/user/user.svg',
  removeAllItemsIconUrl: '',
  alreadyHaveAQuote: () => {
    /* default alreadyHaveAQuote handler */
  },
  isAccountBlocked: false,
  isQuoteToOrderDisabled: false,
  checkoutButtonDisabled: false,
  openBlockedAccountModal: () => {
    /* default openBlockedAccountModal handler */
  },
  openEndSessionModal: () => {
    /* default openEndSessionModal handler */
  },
};

export default ShoppingCartEmpty;
